module.exports = __webpack_public_path__ + "img/ellipse-inside-blur-green-s.e052b32f.svg";